export default __webpack_public_path__ + "static/media/patio-res3.51abe49d.jpg";